import { actionShowModal, actionHideModal } from 'react-redux-app/lib/modules/modal/actions';

import { MODAL_DIALOG__SOCIAL_SETTINGS } from '../../constants/dialogs';


export const actionShowSocialSettingsDialog = () => dispatch => (
  dispatch(actionShowModal(MODAL_DIALOG__SOCIAL_SETTINGS))
);

export const actionHideSocialSettingDialog = () => dispatch => (
  dispatch(actionHideModal(MODAL_DIALOG__SOCIAL_SETTINGS))
);
